const styles = ({ COLORS }) => ({
  button: {
    margin: '0 2px',
    textDecoration: 'none'
  },
  action: {
    textAlign: 'right'
  },
  loading: {
    opacity: '.5',
    pointerEvents: 'none',
    transition: '300ms opacity ease-in-out'
  },
  link: {
    padding: 0,
    display: 'block',
    height: 'auto',
    fontWeight: 'bold'
  },
  plainLink: {
    textDecoration: 'none',
    fontWeight: 'bold',
    color: COLORS.BLUE.NORMAL
  },
  center: {
    textAlign: 'center'
  }
})

export default styles
